export default {
  drafts: {
    title: 'Faturas não emitidas',
    edit: 'Edição',
    view: 'Ver Fatura',
    duplicate: 'Duplicar',
    issue: 'Emitir',
    sendProForm: 'Enviar Pro Forma',
    history: 'Histórico',
    deleteTitle: 'Excluir rascunho selecionado',
    deleteConfirm: 'Tem certeza de que deseja excluir o rascunho selecionado?',
    download: 'Baixar',
    requestText: 'Foi solicitada a emissão das faturas. Você pode consultar as faturas emitidas no menu Emitidas e recebidas, tanto como fornecedor quanto como pagador. A partir dessa tela, você poderá ver os detalhes de uma fatura, gerenciar o pagamento ou baixá-la em diferentes formatos'
  },
  newInvoice: {
    dataTitle: 'Dados gerais',
    detailsTitle: 'Detalhes da fatura',
    paymentTitle: 'Descontos e formas de pagamento',
    summaryTitle: 'Resumo',
    stepBack: 'Ir para o passo anterior',
    saveAsDraft: 'Salvar como rascunho',
    factoringTitle: 'Dados de factoring',
    validationError: 'Ocorreu um erro de validação da fatura',
    factoring: {
      messageOk: 'O financiamento foi solicitado com sucesso',
      messageKo: 'Não foi possível enviar a solicitação de financiamento, tente novamente mais tarde na aba "Financiamento"'
    },
    alertCaixaThirdPartyClientWithLink: 'As faturas direcionadas ao CaixaBank não permitem a criação de suplidos',
    alertTxtMortgageExpenses: 'Para faturar ao departamento de Gastos Hipotecários, deve fazê-lo através do Portal de Fornecedores do CaixaBank',
    alertBFA: `Em razão da fusão entre Bankia, S.A. e CaixaBank, S.A., realizada em 26 de março, o BFA passou a gerenciar diretamente todos os serviços próprios da execução de sua atividade de forma autônoma e independente.<br/><br/>Antecipamos o e-mail criado para a interlocução durante a prestação de seus serviços e pedimos encarecidamente que, daqui em diante, usem como principal meio de comunicação entre as partes: <a href="mailto:informacion@bfa.com.es">informacion@bfa.com.es</a><br/><br/> Nos casos excepcionais em que o anterior não seja possível, podem também se dirigir à sede social do BFA:<br/><div style="text-align:center"><span>BFA TENEDORA DE ACCIONES S.A.<br/>
    AVENIDA GENERAL PERON, 38<br/>EDIFÍCIO MASTER II<br/>28020 MADRID</span></div><br/>Agradecemos desde já sua colaboração e estamos à disposição para quaisquer esclarecimentos necessários.`,
    alertPension: 'Para faturar ao Bankia Pensões, deve fazê-lo através do Portal de Fornecedores do CaixaBank'
  },
  autodrafts: {
    title: 'Autofaturas não emitidas',
    edit: 'Editar Autofatura'
  },
  thirdParty: {
    title: 'Suplidos e terceiros não emitidos'
  },
  ok: '<span style="font-size: 20px;">Para concluir o processo de registro, enviamos um <span style="font-weight: bold">e-mail para {0}</span> para ativar sua conta.</span>'
}